exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-084c01ec] {\n    border: 1px solid red;\n}\n", ""]);

// exports
